import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import style from './Home.module.css';
import Lottie from "lottie-web";
import search from '../../Assets/search.json';
import { DEPARTMENT_OPTIONS, PROPERTY_TYPE_OPTIONS } from '../../utils/filterOptions';
import { filtersToSearchParams } from '../../utils/propertyCatalogFilters';
import LuxuryCard from "../../Components/LuxuryCard/LuxuryCard";
import CardDesarrollo from "../../Components/CardDesarollo/CardDesarrollo";
import ContactUs from "../../Components/ContactUs/ContactUs";
import WorkUs from '../../Components/WorkUs/WorkUs';
import AOS from "aos";
import "aos/dist/aos.css";
import Portada from '../../Assets/portada-home.webp';

const Home = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useState({
        departments: "",
        propertyType: ""
    });
    // Operación seleccionada: define a qué catálogo redirige el buscador.
    const [operation, setOperation] = useState("sale");

    const container = useRef(null);

    useEffect(() => {
        const animation = Lottie.loadAnimation({
            container: container.current,
            renderer: "svg",
            loop: true,
            autoplay: false,
            animationData: search
        });

        return () => {
            animation.destroy();
        };
    }, []);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const handleSearch = () => {
        const params = new URLSearchParams(
            filtersToSearchParams({
                propertyType: searchParams.propertyType,
                departments: searchParams.departments,
            })
        );
        const query = params.toString();
        navigate(query ? `/${operation}?${query}` : `/${operation}`);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // Comprar/Alquilar actúan como toggle de operación del buscador; Vender/Desarrollos navegan directo.
    const actions = [
        { label: 'Quiero comprar', operation: 'sale', icon: '🏠' },
        { label: 'Quiero alquilar', operation: 'rent', icon: '🔑' },
        { label: 'Quiero vender', url: '/sell', icon: '💰' },
        { label: 'Desarrollos', url: '/desarrollo', icon: '🏢' }
    ];

    const handleActionClick = (action) => {
        if (action.operation) {
            setOperation(action.operation);
        } else {
            navigate(action.url);
        }
    };

    return (
        <div className={style.container}>
            <div className={style.intro} data-aos="fade-up" style={{ backgroundImage: `linear-gradient(90deg, rgba(16, 24, 40, 0.62) 0%, rgba(16, 24, 40, 0.52) 30%, rgba(16, 24, 40, 0.18) 100%), url(${Portada})` }}>
                <div className={style.heroContent}>
                    <div className={style.textBlock}>
                        <h1 className={style.title}>Mucho más que <br />mudarte, es elegir <br />tu próximo comienzo.</h1>
                        <p className={style.subtitle}>Te acompañamos en cada paso para que encuentres el lugar que mejor se adapte a tu vida.</p>

                        <div className={style.searchGroup}>
                            <div className={style.buttonsContainer}>
                                {actions.map((action) => (
                                    <button
                                        key={action.label}
                                        className={`${style.button} ${action.operation === operation ? style.buttonActive : ''}`}
                                        onClick={() => handleActionClick(action)}
                                    >
                                        <span className={style.buttonIcon}>{action.icon}</span>
                                        <span>{action.label}</span>
                                    </button>
                                ))}
                            </div>

                            <div className={style.searchPanel}>
                                <div className={style.searchField}>
                                    <label>Tipo de propiedad</label>
                                    <select
                                        name="propertyType"
                                        value={searchParams.propertyType}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Selecciona tu tipo de propiedad</option>
                                        {PROPERTY_TYPE_OPTIONS.map((opt) => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className={style.searchField}>
                                    <label>¿Dónde te gustaría vivir?</label>
                                    <select
                                        name="departments"
                                        value={searchParams.departments}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Selecciona un departamento</option>
                                        {DEPARTMENT_OPTIONS.map((dep) => (
                                            <option key={dep} value={dep}>{dep}</option>
                                        ))}
                                    </select>
                                </div>

                                <button className={style.searchButton} onClick={handleSearch}>
                                    <span className={style.searchLottie}>
                                        <div
                                            ref={container}
                                            onMouseEnter={() => Lottie.play()}
                                            onMouseLeave={() => Lottie.pause()}
                                        />
                                    </span>
                                    <span>Buscar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={style.componentWrapper} data-aos="fade-up">
                <CardDesarrollo />
            </div>
            <div className={style.componentWrapper} data-aos="fade-up">
                <LuxuryCard />
            </div>
            <div className={style.componentWrapper} data-aos="fade-up">
                <ContactUs />
            </div>
            <div className={style.componentWrapper} data-aos="fade-up">
                <WorkUs />
            </div>
            <p className={style.declaracion} data-aos="fade-up">
                By Raices (bajo la sociedad Ditova SAS) NO ejerce el corretaje inmobiliario. Cada oficina es de propiedad y gestión independiente. En cumplimiento de las leyes vigentes que regulan el corretaje inmobiliario, Ley Nacional 25.028, Ley 22.802 de Lealtad Comercial, Ley 24.240 de Defensa al Consumidor, las normas del Código Civil y Comercial de la Nación y Constitucionales, los agentes/gestores de By Raices NO ejercen el corretaje inmobiliario. Todas las operaciones inmobiliarias son objeto de intermediación y conclusión por parte de los corredores públicos inmobiliarios colegiados, cuyos datos se exhiben en cada publicación de propiedad objeto de comercialización.
            </p>
        </div>
    );
};

export default Home;
